// Pub & Newsletter : inscription en ligne. Serveur : functions/api/modules/newsletterInscription.js. Règles : shared/newsletterInscription.js.
import { apiFetch } from './api';

/** Réglages de l'établissement (écran « Inscriptions »). */
export interface ReglagesInscription {
    enabled: boolean;
    token: string | null;
    path: string | null;
    double_optin: boolean;
    title: string;
    intro: string;
    signups_month: number;
    signups_total: number;
    pending: number;
    daily_cap: number;
}

/** Ce que la page publique affiche. */
export interface PageInscription {
    company_name: string;
    logo: string | null;
    title: string;
    intro: string;
    consent_text: string;
    double_optin: boolean;
}

const json = (payload: unknown) => JSON.stringify(payload);

export const newsletterInscriptionApi = {
    reglages: (): Promise<ReglagesInscription> => apiFetch('/marketing/envoi/inscription'),
    regler: (d: Partial<Pick<ReglagesInscription, 'enabled' | 'double_optin' | 'title' | 'intro'>>): Promise<ReglagesInscription> =>
        apiFetch('/marketing/envoi/inscription', { method: 'PUT', body: json(d) }),
    renouvelerLien: (): Promise<ReglagesInscription> => apiFetch('/marketing/envoi/inscription/jeton', { method: 'POST' }),
    // ----- côté public (sans compte) -----
    page: (token: string): Promise<PageInscription> => apiFetch(`/public/marketing/inscription/${encodeURIComponent(token)}`),
    inscrire: (token: string, d: { email: string; name: string; consent: boolean; website: string; opened_at: number; source?: string; insister?: boolean }): Promise<{ success: boolean; pending: boolean }> =>
        apiFetch(`/public/marketing/inscription/${encodeURIComponent(token)}`, { method: 'POST', body: json(d) }),
    infoConfirmation: (token: string): Promise<{ company_name: string }> => apiFetch(`/public/marketing/inscription/confirmer/${encodeURIComponent(token)}`),
    confirmer: (token: string): Promise<{ success: boolean; company_name: string }> => apiFetch(`/public/marketing/inscription/confirmer/${encodeURIComponent(token)}`, { method: 'POST' }),
};
